<!-- 缺陷reopen -->
<template>
  <div :id="chartId" :style="{ height: height, width: width }" />
</template>
<script>
import 'echarts/lib/chart/scatter';

export default {
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    seriesData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    chartId: {
      type: String,
      default: 'issue-chart'
    }
  },
  data() {
    return {
      myChart: null,
      option: {
        legend: { // 对应series的name

        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '2%',
          right: '12%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['P0', 'P1', 'P2', 'P3']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: 'P0-P3分布',
            type: 'bar',
            data: this.seriesData,
            label: {
              normal: {
                show: true,
                position: 'top'
              }
            },
            itemStyle: {
              normal: {
                color: function(params) {
                  var colorList = ['#FF8433', '#33FFEC', '#B233FF', '#FFC933'];
                  return colorList[params.dataIndex];
                }

              }
            }
          }
        ]
      }
    };
  },
  watch: {
    seriesData() {
      this.option.series[0].data = this.seriesData;
      this.getDailyData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 饼图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');

    this.myChart = echarts.init(document.getElementById(this.chartId));
    this.getDailyData();
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option);
      window.addEventListener('resize', () => {
        this.myChart.resize();
      });
    },
    getDailyData() {
      this.drawChart();
    }
  }
};
</script>

